import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [showImpressum, setShowImpressum] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setSubmitMessage('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }
    setIsSubmitting(true);
    setSubmitMessage('');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      const response = await fetch('https://readdy.ai/api/form/d6fksv2n5jm489bu5mgg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (response.ok) {
        setSubmitMessage('Vielen Dank! Sie wurden erfolgreich angemeldet.');
        setEmail('');
      } else {
        setSubmitMessage('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
      }
    } catch {
      setSubmitMessage('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <footer id="footer" className="bg-[#1A2B4A] text-white relative overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 mb-10 sm:mb-12">
            {/* Logo + Newsletter */}
            <div className="md:col-span-4 space-y-5">
              <img
                src="https://public.readdy.ai/ai/img_res/cd59830a-a811-4b8c-95fb-12d94d035ec5.png"
                alt="Elektro Tomasevic KG Logo"
                className="h-14 w-auto brightness-0 invert"
              />
            </div>

            {/* Links Grid */}
            <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
              <div>
                <h4 className="text-[#F4B942] font-bold text-base mb-4">Leistungen</h4>
                <ul className="space-y-2">
                  <li><Link to="/leistungen/photovoltaik" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Photovoltaik</Link></li>
                  <li><Link to="/leistungen/alarmanlagen" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Alarmanlagen</Link></li>
                  <li><Link to="/leistungen/blitzschutz" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Blitzschutz</Link></li>
                  <li><Link to="/leistungen/elektroinstallationen" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Elektroinstallationen</Link></li>
                  <li><Link to="/leistungen/beleuchtung" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Beleuchtung</Link></li>
                </ul>
              </div>

              <div>
                <h4 className="text-[#F4B942] font-bold text-base mb-4">Unternehmen</h4>
                <ul className="space-y-2">
                  <li><a href="#ueber-uns" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Über uns</a></li>
                  <li><a href="#standort" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Bewertungen</a></li>
                </ul>
              </div>

              <div>
                <h4 className="text-[#F4B942] font-bold text-base mb-4">Service</h4>
                <ul className="space-y-2">
                  <li><Link to="/service/notdienst" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Notdienst</Link></li>
                  <li><Link to="/service/wartung" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Wartung</Link></li>
                  <li><Link to="/service/beratung" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm cursor-pointer">Beratung</Link></li>
                </ul>
              </div>

              <div>
                <h4 className="text-[#F4B942] font-bold text-base mb-4">Kontakt</h4>
                <ul className="space-y-2">
                  <li><a href="tel:+436991223301" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm">+43 699 122 333 01</a></li>
                  <li><a href="mailto:elektro.tomasevic@gmail.com" className="text-white/80 hover:text-[#F4B942] transition-colors text-sm">elektro.tomasevic@gmail.com</a></li>
                  <li className="text-white/80 text-sm">Maroltingergasse 92/1/5</li>
                  <li className="text-white/80 text-sm">1160 Wien</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-6 sm:pt-8">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
              <p className="text-white/70 text-sm text-center sm:text-left">
                © 2025 Elektro Tomasevic KG
              </p>

              <div className="flex items-center flex-wrap justify-center gap-3 text-white/70 text-sm">
                <button
                  onClick={() => setShowImpressum(true)}
                  className="hover:text-[#F4B942] transition-colors whitespace-nowrap cursor-pointer"
                >
                  Impressum
                </button>
                <span>|</span>
                <a href="#datenschutz" className="hover:text-[#F4B942] transition-colors whitespace-nowrap">Datenschutz</a>
                <span>|</span>
                <a href="#agb" className="hover:text-[#F4B942] transition-colors whitespace-nowrap">AGB</a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showImpressum && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowImpressum(false)}>
          <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto p-6 sm:p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#1A2B4A]">Impressum</h2>
              <button onClick={() => setShowImpressum(false)} className="text-gray-500 hover:text-[#1A2B4A] text-3xl leading-none cursor-pointer">×</button>
            </div>
            <div className="space-y-4 text-[#1A2B4A]" style={{ lineHeight: '1.6' }}>
              <div><p className="font-bold text-lg">Firmenname:</p><p>Elektro Tomasevic KG</p></div>
              <div><p className="font-bold text-lg">Adresse:</p><p>Maroltingergasse 92/1/5</p><p>1160 Wien, Österreich</p></div>
              <div><p className="font-bold text-lg">Telefon:</p><p>+43 699 122 333 01</p></div>
              <div><p className="font-bold text-lg">E-Mail:</p><p><a href="mailto:elektro.tomasevic@gmail.com" className="text-[#F4B942] hover:underline">elektro.tomasevic@gmail.com</a></p></div>
              <div><p className="font-bold text-lg">Firmenbuchnummer:</p><p>FN 399263 b</p></div>
              <div><p className="font-bold text-lg">UID-Nummer:</p><p>ATU69634737</p></div>
              <div><p className="font-bold text-lg">Unternehmensgegenstand:</p><p>Elektroinstallationen; Vermietung und Installation von Beleuchtungs- und Beschallungseinrichtungen.</p></div>
              <div><p className="font-bold text-lg">Aufsichtsbehörde:</p><p>Magistrat der Stadt Wien</p></div>
              <div><p className="font-bold text-lg">Berufsrecht:</p><p>Gewerbeordnung: <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer" className="text-[#F4B942] hover:underline">www.ris.bka.gv.at</a></p></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
